import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Import HTTPS validator for security
import { httpsValidator } from './utils/https-validator.js'

// Initialize HTTPS validation
httpsValidator.init()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)